import { Component } from '@angular/core';
import { config } from '../../../../environments/environment';

@Component({
  selector: 'app-new-project-api',
  standalone: false,
  templateUrl: './new-project-api.component.html',
})
export class NewProjectApiComponent {
  redirect_url: string = config.new_project_url;

  ngOnInit(): void {
      if (window.location.hostname != 'localhost') {
        window.location.href = `${window.location.origin}/ndcportal/index.html`;
      } else {
        window.location.href = this.redirect_url;
      }
  }
}
